import { LOCATION_CHANGE } from 'connected-react-router';
import { Action } from 'redux-actions';
import { ActionsObservable, combineEpics, ofType, StateObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { MenuActionType } from '../menu/MenuActions';
import { articlesActions, ArticlesActionType } from './ArticlesActions';
import { StoreState, StoreStateWithRouter } from '../store/StoreState';
import { extractCategories } from '../menu/CategoriesExtractor';
import { contentfulClient } from '../contentful/contentfulClient';
import { merge, of } from 'rxjs';

const findCategories = ({router: {location}, menu: {menuItems}}: StoreStateWithRouter) =>
    extractCategories(location, menuItems);

function urlBasedArticlesLoaderTriggerEpic(actions$: ActionsObservable<Action<any>>,
                                           state$: StateObservable<StoreState>): Observable<Action<any>> {

    return actions$.pipe(
        ofType(MenuActionType.DATA_LOAD_SUCCESS, LOCATION_CHANGE as string),
        withLatestFrom(state$),
        filter(([, state]) => (state as StoreState).menu.loaded),
        map(([, state]) => articlesActions.articlesLoadStart(findCategories(state as StoreStateWithRouter)))
    );
}

function articlesLoaderEpic(actions$: ActionsObservable<Action<any>>,
                            state$: StateObservable<StoreState>): Observable<Action<any>> {
    return actions$.pipe(
        ofType(ArticlesActionType.ARTICLES_LOAD_START),
        switchMap((action: Action<Array<string>>) => merge(
            of(articlesActions.articlesLoading()),
            contentfulClient.getArticles(action.payload!).pipe(
                map(payload => articlesActions.articlesLoadSuccess(payload)),
                catchError(err => of(articlesActions.articlesLoadFailed(err)))
            ))
        )
    );

}

export const articlesEpic = combineEpics(
    urlBasedArticlesLoaderTriggerEpic,
    articlesLoaderEpic,
);


// WEBPACK FOOTER //
// ./src/article/ArticlesEpic.ts